module.exports = __webpack_public_path__ + "img/fo.561d8e5c.svg";